var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import * as _ from 'lodash';
import gql from 'graphql-tag';
import FilterList from './FilterList.vue';
import { whereQuery } from '@/services/sharedForm';
import getUser from '@/services/user';
import { exportCsv } from '@/services/importExport';
import { LOCATIONS_EXTERNAL, BOLS_EXTERNAL } from '@/queries/bols';
var ExternalLogList = /** @class */ (function (_super) {
    __extends(ExternalLogList, _super);
    function ExternalLogList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bols = [];
        _this.bolData = {};
        _this.loading = false;
        _this.pageArr = [];
        _this.sortDir = 'desc';
        _this.sortField = 'date';
        _this.bolUnsubscribe = null;
        _this.errMsg = null;
        _this.user = {};
        _this.csvExportLoading = false;
        _this.options = {
            showProduct: true,
            showSearch: true,
            showLocation: false,
            showTimeframe: true,
            selectedProduct: {},
            selectedLocation: {},
            searchQuery: '',
            selectedTimeframe: 'This Week',
            selectedQuery: 'PO #',
            changeOptions: function () { return _this.filterChanged(); },
            altLocations: []
        };
        return _this;
    }
    ExternalLogList.prototype.metaInfo = function () {
        return {
            title: 'Log List'
        };
    };
    ExternalLogList.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, storedOptions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, getUser()];
                    case 1:
                        _a.user = _b.sent();
                        if (typeof (Storage) !== "undefined") {
                            storedOptions = JSON.parse(localStorage.getItem("log_list_filters"));
                            this.options = Object.assign(this.options, storedOptions);
                            this.options.showLocation = false;
                            this.options.selectedLocation = {};
                            this.options.altLocations = [];
                            this.options.customer = {
                                name: this.user.company
                            };
                        }
                        this.getLocations();
                        this.getBols();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ExternalLogList.prototype, "filterInUse", {
        get: function () {
            return (this.options.selectedProduct && this.options.selectedProduct.name) ||
                (this.options.searchQuery && this.options.searchQuery.length);
        },
        enumerable: true,
        configurable: true
    });
    ExternalLogList.prototype.exportCsvData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.csvExportLoading = true;
                        return [4 /*yield*/, exportCsv(whereQuery(this.options), this.sortDir, 'Daily Log List.csv')];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error creating CSV file. Please try again.',
                            position: 'is-top',
                            type: 'is-warning'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.csvExportLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ExternalLogList.prototype.filterChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof (Storage) !== "undefined") {
                            localStorage.setItem("log_list_filters", JSON.stringify(this.options));
                        }
                        return [4 /*yield*/, this.getBols()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalLogList.prototype.onSort = function (field, order) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sortDir = order;
                        return [4 /*yield*/, this.getBols()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalLogList.prototype.getLocations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ", ""], ["query ", ""])), LOCATIONS_EXTERNAL),
                                variables: {
                                    where: whereQuery(this.options),
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 1:
                        res = _a.sent();
                        if (!res.data) {
                            throw new Error('No data');
                        }
                        this.options.altLocations = _.map(res.data.bols, function (bol) {
                            return { name: bol.location };
                        });
                        this.options.showLocation = this.options.altLocations.length ? true : false;
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.options.altLocations = [];
                        this.options.showLocation = false;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ExternalLogList.prototype.getBols = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, bolData_1, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        this.errMsg = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["query ", ""], ["query ", ""])), BOLS_EXTERNAL),
                                variables: {
                                    where: whereQuery(this.options),
                                    sort: this.sortDir
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 2:
                        res = _a.sent();
                        if (!res.data) {
                            throw new Error('No data');
                        }
                        this.bols = res.data.bols;
                        bolData_1 = [];
                        _.forEach(this.bols, function (bol) {
                            var productIndex = _.findIndex(bolData_1, { name: bol.product });
                            if (productIndex === -1) {
                                bolData_1.push({
                                    name: bol.product,
                                    incomingWeight: 0,
                                    outgoingWeight: 0,
                                    incomingTons: 0,
                                    outgoingTons: 0
                                });
                                productIndex = bolData_1.length - 1;
                            }
                            var netWeight = bol.weights_aggregate.aggregate.sum.net_weight;
                            if (netWeight > 0) {
                                bolData_1[productIndex].incomingWeight += netWeight;
                                bolData_1[productIndex].incomingTons += netWeight / 2000;
                            }
                            else {
                                bolData_1[productIndex].outgoingWeight += Math.abs(netWeight);
                                bolData_1[productIndex].outgoingTons += Math.abs(netWeight) / 2000;
                            }
                        });
                        this.bolData = bolData_1;
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        this.errMsg = 'There was an error getting the list. Please try again.';
                        this.bols = [];
                        this.$toast.open({
                            duration: 5000,
                            message: this.errMsg,
                            position: 'is-top',
                            type: 'is-danger'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalLogList = __decorate([
        Component({
            name: 'external-log-list',
            components: {
                'filterList': FilterList
            }
        })
    ], ExternalLogList);
    return ExternalLogList;
}(Vue));
export default ExternalLogList;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalLogList.vue
// module id = 785
// module chunks = 1